// Developer Note : this page is modified from offer to banner
import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import {
  ManageBranchOffers,
  ManageOffers,
  showMessage,
  getToken,
} from "../../Functionalities/Functions";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import {
  is_superuser,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  protocol,
} from "../../Functionalities/Config";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingComponent from "../../CoreComponents/LoadingComponent";

function Body() {
  const [radio, setRadio] = useState({
    item: true,
    restaurant: false,
  });
  const [noPdtData, setnoPdtData] = useState(true);
  const [noBranchData, setnoBranchData] = useState(true);

  const [loading, setLoading] = useState(true);

  const [nextPdtOffers, setPdtOffersNext] = useState("");
  const [prevPdtOffers, setPdtOffersPrev] = useState("");

  const [pdtOffers, setPdtOffers] = useState({ id: "", name: "", data: [] });
  const [branchOffers, setBranchOffers] = useState({
    id: "",
    name: "",
    data: [],
  });

  const [nextbranchOffers, setbranchOffersNext] = useState("");
  const [prevbranchOffers, setbranchOffersPrev] = useState("");

  useEffect(() => {
    fetchProductOffers();
    fetchBranchOffers();
  }, []);

  const fetchProductOffers = () => {
    let result = ManageOffers("", "", "get", "offer_type=item");
    result
      .then((result) => {
        setPdtOffers({ ...pdtOffers, data: result.data.results });
        setLoading(false);
        if (result.data.results.length > 0) {
          setnoPdtData(false);
        }
        setPdtOffersNext(result.data.next);
        setPdtOffersPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const handlePrevPdtOffers = () => {
    var config = {
      method: "get",
      url: prevPdtOffers.replace("http:", protocol.replace("//", "")),
      headers: { Authorization: getToken() },
    };

    axios(config)
      .then(function (response) {
        setPdtOffers({
          ...pdtOffers,
          data: response.data.results,
        });
        setPdtOffersNext(response.data.next);
        setPdtOffersPrev(response.data.previous);
      })
      .catch(function (error) {});
  };

  const handleNextPdtOffers = () => {
    var config = {
      method: "get",
      url: nextPdtOffers.replace("http:", protocol.replace("//", "")),
      headers: { Authorization: getToken() },
    };

    axios(config)
      .then(function (response) {
        setPdtOffers({
          ...pdtOffers,
          data: response.data.results,
        });
        setPdtOffersNext(response.data.next);
        setPdtOffersPrev(response.data.previous);
      })
      .catch(function (error) {});
  };

  const fetchBranchOffers = () => {
    let result = ManageOffers("", "", "get", "offer_type=branch");
    result
      .then((result) => {
        setBranchOffers({ ...branchOffers, data: result.data.results });
        setLoading(false);
        if (result.data.results.length > 0) {
          setnoBranchData(false);
        }
        setbranchOffersNext(result.data.next);
        setbranchOffersPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const handlePrevbranchOffers = () => {
    var config = {
      method: "get",
      url: prevbranchOffers.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        setBranchOffers({
          ...branchOffers,
          data: response.data.results,
        });
        setbranchOffersNext(response.data.next);
        setbranchOffersPrev(response.data.previous);
      })
      .catch(function (error) {});
  };

  const handleNextbranchOffers = () => {
    var config = {
      method: "get",
      url: nextbranchOffers.replace("http:", protocol.replace("//", "")),
      headers: { Authorization: getToken() },
    };

    axios(config)
      .then(function (response) {
        setBranchOffers({
          ...branchOffers,
          data: response.data.results,
        });
        setbranchOffersNext(response.data.next);
        setbranchOffersPrev(response.data.previous);
      })
      .catch(function (error) {});
  };

  return (
    <div class="content-body">
      {!loading ? (
        <>
          {
            <div class="container-fluid">
              <FilterComponent
                handleNext={
                  radio.item ? handleNextPdtOffers : handleNextbranchOffers
                }
                handlePrev={
                  radio.item ? handlePrevPdtOffers : handlePrevbranchOffers
                }
                next={radio.item ? nextPdtOffers : nextbranchOffers}
                prev={radio.item ? prevPdtOffers : prevbranchOffers}
                addItemName={"Add Banner"}
                addItemPath={"/addbanner"}
              />

              <div className="row">
                <div className="col-xl-12 ">
                  <div className="card">
                    <div className="card-body">
                      <form>
                        <div className="form-group mb-0">
                          <label className="radio-inline mr-5">
                            <input
                              type="radio"
                              name="optradio"
                              checked={radio.item}
                              value={radio.item}
                              onChange={(e) => {
                                setRadio({
                                  ...radio,
                                  item: true,
                                  restaurant: false,
                                });
                              }}
                            />{" "}
                            Items
                          </label>

                          <label className="radio-inline mr-5">
                            <input
                              type="radio"
                              name="optradio"
                              value={radio.restaurant}
                              checked={radio.restaurant}
                              onChange={(e) => {
                                setRadio({
                                  ...radio,
                                  restaurant: true,
                                  item: false,
                                });
                              }}
                            />{" "}
                            Restaurants
                          </label>
                        </div>
                      </form>
                    </div>
                    {
                      <div className="card-body table-responsive">
                        {radio.item &&
                          (!noPdtData ? (
                            <table className="table table-responsive-md">
                              <thead>
                                <tr>
                                  <th>BANNER ID</th>
                                  <th>ITEM</th>
                                  <th>HEADING</th>
                                  <th>IMAGE</th>
                                  <th>EXPIRY DATE</th>
                                  <th>ACTION</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pdtOffers.data.length > 0 &&
                                  pdtOffers.data.map((offer, index) => {
                                    {
                                      var running = true;
                                      var d1 = new Date();
                                      var d2 = new Date(offer.ex_date);
                                      if (d1.getTime() === d2.getTime()) {
                                      } else if (d1.getTime() < d2.getTime()) {
                                        running = true;
                                      } else if (d1.getTime() > d2.getTime()) {
                                        running = false;
                                      }
                                    }
                                    return (
                                      <tr>
                                        <td>
                                          <h5 className="mb-0 fs--1">
                                            {" "}
                                            FDROFRPDT{offer.id}
                                          </h5>
                                          {
                                            <>
                                              <div
                                                className="mt-2"
                                                style={{
                                                  marginTop: "10px",
                                                  border: "1px solid red",
                                                  borderRadius: "5px",
                                                  padding: "3px",
                                                  borderColor: "#51B04A",
                                                  fontWeight: "bold",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  color: "white",
                                                  backgroundColor: running
                                                    ? "#51B04A"
                                                    : "red",
                                                  fontSize: 12,
                                                }}
                                              >
                                                <span
                                                  style={{ display: "flex" }}
                                                >
                                                  {running
                                                    ? "Running"
                                                    : "Expired"}
                                                </span>
                                              </div>
                                              <div
                                                className="mt-2"
                                                title="this will order the offers in the app"
                                                style={{
                                                  marginTop: "10px",
                                                  border: "2px solid",
                                                  borderRadius: "5px",
                                                  padding: "3px",
                                                  borderColor:
                                                    offer.is_hero_offer
                                                      ? "red"
                                                      : "grey",
                                                  fontWeight: "bold",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  color: offer.is_hero_offer
                                                    ? "red"
                                                    : "white",
                                                  backgroundColor:
                                                    offer.is_hero_offer
                                                      ? "yellow"
                                                      : "grey",
                                                  fontSize: 12,
                                                }}
                                              >
                                                <span
                                                  style={{ display: "flex" }}
                                                >
                                                  {offer.is_hero_offer
                                                    ? "Hero Banner"
                                                    : "Normal Banner"}
                                                </span>
                                              </div>
                                            </>
                                          }
                                        </td>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <span className="w-space-no">
                                              {offer.item?.name}

                                              <br />
                                              {(is_franchise_admin ||
                                                is_franchise_manager ||
                                                is_franchise_staff) &&
                                                offer.item.branch.name}
                                            </span>
                                          </div>
                                        </td>

                                        <td>
                                          <div className="d-flex align-items-center">
                                            <span className="w-space-no">
                                              {offer.heading}
                                            </span>
                                          </div>
                                        </td>

                                        <td>
                                          <div
                                            className="col-sm-9"
                                            style={{ display: "flex" }}
                                          >
                                            {offer.is_hero_offer === true ? (
                                              <img
                                                style={{
                                                  height: 90,
                                                  width: 250,
                                                }}
                                                className="img-fluid rounded mr-3"
                                                src={
                                                  offer.image &&
                                                  offer.image.image
                                                }
                                              ></img>
                                            ) : (
                                              <>
                                                <img
                                                  style={{
                                                    height: 90,
                                                    width: 90,
                                                  }}
                                                  className="img-fluid rounded mr-3"
                                                  src={
                                                    offer.image &&
                                                    offer.image.image
                                                  }
                                                ></img>
                                                <img
                                                  style={{
                                                    height: 90,
                                                    width: 120,
                                                  }}
                                                  className="img-fluid rounded mr-3"
                                                  src={
                                                    offer.second_image &&
                                                    offer.second_image.image
                                                  }
                                                ></img>
                                              </>
                                            )}
                                          </div>
                                        </td>

                                        <td>
                                          <div className="d-flex align-items-center">
                                            <span className="w-space-no">
                                              {offer.expiry_date
                                                ? offer.expiry_date.slice(0, 10)
                                                : "--"}
                                            </span>
                                          </div>
                                        </td>

                                        <td>
                                          <div className="d-flex">
                                            {
                                              <div className="form-group row">
                                                <div className="col-sm-9">
                                                  <p>
                                                    <a
                                                      href={`/editbanner/${offer.id}/item`}
                                                      title={`go to ${offer.id}`}
                                                    >
                                                      <span className="btn btn-primary shadow btn-xs sharp mr-1 item">
                                                        <i className="fa fa-pencil"></i>
                                                      </span>
                                                    </a>
                                                  </p>
                                                </div>
                                              </div>
                                            }

                                            <div
                                              onClick={(e) => {
                                                e.preventDefault();

                                                confirmAlert({
                                                  customUI: ({ onClose }) => {
                                                    return (
                                                      <div
                                                        className="custom-ui"
                                                        style={{
                                                          borderRadius: 8,
                                                          border: "solid",
                                                          padding: 70,
                                                          borderWidth: 0.5,
                                                        }}
                                                      >
                                                        <h1>Are you sure?</h1>
                                                        <p>
                                                          You want to delete
                                                          item offer ?
                                                        </p>
                                                        <button
                                                          onClick={onClose}
                                                          className="btn btn-primary"
                                                          style={{
                                                            marginRight: 10,
                                                          }}
                                                        >
                                                          {" "}
                                                          Cancel
                                                        </button>
                                                        <button
                                                          onClick={() => {
                                                            let res =
                                                              ManageOffers(
                                                                e,
                                                                "",
                                                                "delete",
                                                                `id=${offer.id}`
                                                              );
                                                            res
                                                              .then((res) => {
                                                                if (res) {
                                                                  showMessage(
                                                                    "Delete success",
                                                                    "success",
                                                                    "Success!",
                                                                    "top",
                                                                    "top-right"
                                                                  );

                                                                  window.location.replace(
                                                                    "/banners"
                                                                  );
                                                                } else {
                                                                  showMessage(
                                                                    "delete failed",
                                                                    "danger",
                                                                    "Failed!",
                                                                    "top",
                                                                    "top-right"
                                                                  );
                                                                }
                                                              })
                                                              .catch((err) => {
                                                                showMessage(
                                                                  "delete failed",
                                                                  "danger",
                                                                  "Error!",
                                                                  "top",
                                                                  "top-right"
                                                                );
                                                              });
                                                          }}
                                                          className="btn btn-primary"
                                                        >
                                                          Delete
                                                        </button>
                                                      </div>
                                                    );
                                                  },
                                                });
                                              }}
                                            >
                                              <span className="btn btn-danger shadow btn-xs sharp">
                                                <i className="fa fa-trash" />
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          ) : (
                            <NoDataComponent data="Product Banners" />
                          ))}
                        {radio.restaurant &&
                          (!noBranchData ? (
                            <table className="table table-responsive-md">
                              <thead>
                                <tr>
                                  <th>BANNER ID</th>

                                  {true && radio.restaurant && (
                                    <th>RESTAURANT</th>
                                  )}
                                  <th>HEADING</th>
                                  <th>IMAGE</th>
                                  <th>EXPIRY DATE</th>
                                  <th>ACTION</th>
                                </tr>
                              </thead>
                              <tbody>
                                {branchOffers.data.length > 0 &&
                                  branchOffers.data.map((offer, index) => {
                                    {
                                      var running = true;
                                      var d1 = new Date();
                                      var d2 = new Date(offer.ex_date);
                                      if (d1.getTime() === d2.getTime()) {
                                      } else if (d1.getTime() < d2.getTime()) {
                                        running = true;
                                      } else if (d1.getTime() > d2.getTime()) {
                                        running = false;
                                      }
                                    }
                                    return (
                                      <tr>
                                        <td>
                                          <h5 className="mb-0 fs--1">
                                            {" "}
                                            FDROFRRST{offer.id}
                                          </h5>
                                          <div
                                            className="mt-2"
                                            style={{
                                              marginTop: "10px",
                                              border: "1px solid red",
                                              borderRadius: "5px",
                                              padding: "3px",
                                              borderColor: "#51B04A",
                                              fontWeight: "bold",
                                              display: "flex",
                                              justifyContent: "center",
                                              color: "white",
                                              backgroundColor: running
                                                ? "#51B04A"
                                                : "red",
                                              fontSize: 12,
                                            }}
                                          >
                                            <span style={{ display: "flex" }}>
                                              {running ? "Running" : "Expired"}
                                            </span>
                                          </div>
                                          <div
                                            className="mt-2"
                                            title="this will order the offers in the app"
                                            style={{
                                              marginTop: "10px",
                                              border: "2px solid",
                                              borderRadius: "5px",
                                              padding: "3px",
                                              borderColor: offer.is_hero_offer
                                                ? "red"
                                                : "grey",
                                              fontWeight: "bold",
                                              display: "flex",
                                              justifyContent: "center",
                                              color: offer.is_hero_offer
                                                ? "red"
                                                : "white",
                                              backgroundColor:
                                                offer.is_hero_offer
                                                  ? "yellow"
                                                  : "grey",
                                              fontSize: 12,
                                            }}
                                          >
                                            <span style={{ display: "flex" }}>
                                              {offer.is_hero_offer
                                                ? "Hero Banner"
                                                : "Normal Banner"}
                                            </span>
                                          </div>
                                        </td>
                                        {(is_franchise_admin ||
                                          is_franchise_manager ||
                                          is_franchise_staff) &&
                                          radio.restaurant && (
                                            <td>
                                              <div className="d-flex align-items-center">
                                                <span className="w-space-no">
                                                  {offer.branch.name}
                                                </span>
                                              </div>
                                            </td>
                                          )}
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <span className="w-space-no">
                                              {offer.heading}
                                            </span>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            className="col-sm-9"
                                            style={{ display: "flex" }}
                                          >
                                            {offer.is_hero_offer === true ? (
                                              <img
                                                style={{
                                                  height: 90,
                                                  width: 250,
                                                }}
                                                className="img-fluid rounded mr-3"
                                                src={offer.image?.image}
                                              />
                                            ) : (
                                              <>
                                                <img
                                                  style={{
                                                    height: 90,
                                                    width: 90,
                                                  }}
                                                  className="img-fluid rounded mr-3"
                                                  src={offer.image?.image}
                                                ></img>
                                                <img
                                                  style={{
                                                    height: 90,
                                                    width: 120,
                                                  }}
                                                  className="img-fluid rounded mr-3"
                                                  src={
                                                    offer.second_image?.image
                                                  }
                                                ></img>
                                              </>
                                            )}
                                          </div>
                                        </td>

                                        <td>
                                          <div className="d-flex align-items-center">
                                            <span className="w-space-no">
                                              {offer.expiry_date
                                                ? offer.expiry_date.slice(0, 10)
                                                : "--"}
                                            </span>
                                          </div>
                                        </td>

                                        <td>
                                          <div className="d-flex">
                                            {
                                              <div className="form-group row">
                                                <div className="col-sm-9">
                                                  <p>
                                                    <a
                                                      href={`/editbanner/${offer.id}/branch`}
                                                      title={`edit product`}
                                                    >
                                                      <span className="item btn btn-primary shadow btn-xs sharp mr-1">
                                                        <i className="fa fa-pencil"></i>
                                                      </span>
                                                    </a>
                                                  </p>
                                                </div>
                                              </div>
                                            }

                                            <div
                                              onClick={(e) => {
                                                e.preventDefault();

                                                confirmAlert({
                                                  customUI: ({ onClose }) => {
                                                    return (
                                                      <div
                                                        className="custom-ui"
                                                        style={{
                                                          borderRadius: 8,
                                                          border: "solid",
                                                          padding: 70,
                                                          borderWidth: 0.5,
                                                        }}
                                                      >
                                                        <h1>Are you sure?</h1>
                                                        <p>
                                                          You want to delete
                                                          restaurant offer ?
                                                        </p>
                                                        <button
                                                          onClick={onClose}
                                                          className="btn btn-primary"
                                                          style={{
                                                            marginRight: 10,
                                                          }}
                                                        >
                                                          Cancel
                                                        </button>
                                                        <button
                                                          onClick={() => {
                                                            let res =
                                                              ManageBranchOffers(
                                                                e,
                                                                "",
                                                                "delete",
                                                                `id=${offer.id}`
                                                              );
                                                            res
                                                              .then((res) => {
                                                                if (res) {
                                                                  showMessage(
                                                                    "Delete success",
                                                                    "success",
                                                                    "Success!",
                                                                    "top",
                                                                    "top-right"
                                                                  );

                                                                  window.location.replace(
                                                                    "/banners"
                                                                  );
                                                                } else {
                                                                  showMessage(
                                                                    "delete failed",
                                                                    "danger",
                                                                    "Failed!",
                                                                    "top",
                                                                    "top-right"
                                                                  );
                                                                }
                                                              })
                                                              .catch((err) => {
                                                                showMessage(
                                                                  "delete failed",
                                                                  "danger",
                                                                  "Error!",
                                                                  "top",
                                                                  "top-right"
                                                                );
                                                              });
                                                          }}
                                                          className="btn btn-primary"
                                                        >
                                                          Delete
                                                        </button>
                                                      </div>
                                                    );
                                                  },
                                                });
                                              }}
                                            >
                                              <span className="btn btn-danger shadow btn-xs sharp">
                                                <i className="fa fa-trash" />
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          ) : (
                            <NoDataComponent data="Restaurant Banner" />
                          ))}

                        {(is_superuser === false ||
                          is_franchise_admin === false ||
                          is_franchise_manager === false ||
                          is_franchise_staff === false) && <></>}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
}

function Banners() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Banners"}
          subHeading={"Restaurant and product banners under foodoor"}
        />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Banners;
